import { BulletList } from "@tiptap/extension-bullet-list";

const BulletListCustom = BulletList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      type: {
        default: null,
        parseHTML: (element) => {
          const type = element.getAttribute("type");
          const style = element.getAttribute("style");
          // Check style attribute for list-style-type
          if (style && style.includes("list-style-type")) {
            const match = style.match(/list-style-type:\s*([^;]+)/);
            if (match) {
              return match[1].trim();
            }
          }
          return type || null;
        },
        renderHTML: (attributes) => {
          if (!attributes.type || attributes.type === "disc") {
            return {};
          }
          return {
            type: attributes.type,
            style: `list-style-type: ${attributes.type};`,
          };
        },
      },
    };
  },

  addCommands() {
    return {
      ...this.parent?.(),
      setBulletList:
        (attributes = {}) =>
        ({ commands, state, dispatch }) => {
          const { $from } = state.selection;
          let inBulletList = false;
          let listPos = null;
          
          // Check if we're already in a bullet list
          for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            if (node.type.name === "bulletList") {
              inBulletList = true;
              listPos = $from.before(depth);
              break;
            }
          }
          
          // If already in bullet list, update attributes without toggling
          if (inBulletList && listPos !== null) {
            const tr = state.tr;
            const listNode = state.doc.nodeAt(listPos);
            if (listNode) {
              const newAttrs = { ...listNode.attrs };
              // Merge new attributes
              Object.keys(attributes).forEach(key => {
                if (attributes[key] === null || attributes[key] === undefined) {
                  delete newAttrs[key];
                } else {
                  newAttrs[key] = attributes[key];
                }
              });
              tr.setNodeMarkup(listPos, undefined, newAttrs);
              dispatch(tr);
              return true;
            }
          }
          
          // Otherwise, toggle the list on with attributes
          return commands.toggleList(this.name, "listItem", attributes);
        },
    };
  },
});

export default BulletListCustom;
